import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { usePanelPosition } from '../contexts/PanelPositionContext';
import { X } from 'lucide-react';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import SortablePanel from './SortablePanel';

interface LeftPanelProps {
  isLeftPanelVisible: boolean;
  onClose: () => void;
  leftPanels: Array<{
    id: string;
    title: string;
    component: React.ReactNode;
  }>;
  leftPanelsOrder: string[];
}

const LeftPanel: React.FC<LeftPanelProps> = ({
  isLeftPanelVisible,
  onClose,
  leftPanels,
  leftPanelsOrder,
}) => {
  const { theme } = useTheme();
  const { isPanelOnRight } = usePanelPosition();

  if (!isLeftPanelVisible) return null;

  return (
    <div className={`w-64 min-w-64 max-w-64 opacity-100 px-2 ${theme === 'light' ? 'theme-bg-secondary' : ''} theme-border ${isPanelOnRight ? 'border-l' : 'border-r'} pb-[60px] space-y-2 overflow-hidden overflow-y-auto h-screen flex-shrink-0 transition-all duration-300 ease-in-out scrollbar-hide relative`}>
      {/* Close Button - Only visible on hover */}
      <div className="flex items-center justify-end mb-0 absolute top-1 right-2 z-30" style={{ top: '7px' }}>
        <button
          onClick={onClose}
          className="p-1 rounded-sm transition-all duration-200"
          title="Close panel"
        >
          <X className="h-3 w-3 theme-text-quaternary group-hover:text-white transition-colors duration-200" />
        </button>
      </div>
      
      <SortableContext
        items={leftPanelsOrder}
        strategy={verticalListSortingStrategy}
      >
        {leftPanelsOrder.map((panelId) => {
          const panel = leftPanels.find(p => p.id === panelId);
          return panel ? <SortablePanel key={panel.id} panel={panel} /> : null;
        })}
      </SortableContext>
    </div>
  );
};

export default LeftPanel;
